'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/blacklisted-cards',
        name: 'blacklisted-cards',
        meta: {
            title: 'Blacklisted Cards',
            scopes: ['read_blacklisted_cards', 'write_blacklisted_cards']
        },
        component: () => view('blacklisted-cards/index')
    }
];
